import React from "react"
import { MainCP } from "../../../Components/conocimiento/conocimiento-v2/MainCP"

const ViewConocimiento: React.FC = () => <MainCP/>

export default ViewConocimiento